import { SelectionModel } from "@angular/cdk/collections";
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from "@angular/material/form-field";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fadeInUp400ms } from "src/@vex/animations/fade-in-up.animation";
import { stagger40ms } from "src/@vex/animations/stagger.animation";
import { TableColumn } from "src/@vex/interfaces/table-column.interface";
import {
  AuctionTranslationWithRelations,
  AuctionWithRelations,
} from "src/app/api/models";

@Component({
  selector: "app-item-preview-auctions",
  templateUrl: "./auctions.component.html",
  styleUrls: ["./auctions.component.scss"],
  animations: [fadeInUp400ms, stagger40ms],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: "fill",
      } as MatFormFieldDefaultOptions,
    },
  ],
  standalone: false,
})
export class ItemPreviewAuctionsComponent implements OnInit, AfterViewInit {
  @Input() auctions: AuctionWithRelations[] = [];
  @Input() lang: string = "cs";

  /** Main Data */
  tableData: AuctionWithRelations[] = [];

  /** Support Data */

  // Table Properties
  pageSize = 10;
  pageSizeOptions: number[] = [];
  dataSource: MatTableDataSource<AuctionWithRelations> = new MatTableDataSource(
    []
  );

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  //Table Default Values
  DEFAULT_SORT: Sort = { active: "year", direction: "desc" };

  TABLE_COLUMNS: TableColumn<AuctionWithRelations>[] = [
    {
      label: "Název aukce",
      property: "originalTitle",
      type: "text",
      visible: true,
      cssClasses: ["font-semibold"],
    },
    {
      label: "Místo konání",
      property: "place",
      type: "text",
      visible: true,
    },
    {
      label: "Rok konání",
      property: "year",
      type: "text",
      visible: true,
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.tableData = this.auctions;
    this.dataSource.data = this.auctions;
    this.sort.active = this.DEFAULT_SORT.active;
    this.sort.direction = this.DEFAULT_SORT.direction;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit() {
    // this.sort.active = this.DEFAULT_SORT.active;
    // this.sort.direction = this.DEFAULT_SORT.direction;
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  getTranslation(
    auction: AuctionWithRelations,
    lang?: string
  ): AuctionTranslationWithRelations | undefined {
    const translation = auction.translations?.find(
      (translation) => translation.localeId === (lang === "en" ? 2 : 1)
    );
    return translation;
  }

  /* ---------------------------------------------------------
  TABLE CONTENT METHODS
  --------------------------------------------------------- */
  /** Prepares array of visible columns based on "visible" value */
  get visibleColumns() {
    return this.TABLE_COLUMNS.filter((column) => column.visible).map(
      (column) => column.property
    );
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }
}
